import { render, staticRenderFns } from "./Risk.vue?vue&type=template&id=5f55763d&scoped=true&"
import script from "./Risk.vue?vue&type=script&lang=js&"
export * from "./Risk.vue?vue&type=script&lang=js&"
import style0 from "./Risk.vue?vue&type=style&index=0&id=5f55763d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f55763d",
  null
  
)

export default component.exports